import { Controller } from "@hotwired/stimulus"

// Toggles `class="dark"` on <html>. Atualiza otimisticamente (DOM primeiro)
// e persiste no servidor via POST /theme em background — mesma estratégia
// do language switcher. Servidor seta `user.theme` (se logado) e o cookie.
//
// A11y: anuncia a mudança via toast (live region — definida no
// `_toast_container`). Mensagens em pt/en/es vêm do `data-*` no botão
// (passadas pelo partial _theme_toggle).
export default class extends Controller {
  static values = {
    announceLight: { type: String, default: "" },
    announceDark:  { type: String, default: "" }
  }

  toggle() {
    const isDark = document.documentElement.classList.toggle("dark")
    const theme  = isDark ? "dark" : "light"

    // Aplica a cor primária do tema atual já no DOM (sem esperar o POST).
    // Também atualiza --color-ring (focus state dos inputs).
    const body  = document.body
    const key   = isDark ? "--color-primary-dark" : "--color-primary-white"
    const color = body.style.getPropertyValue(key).trim()
    if (color) {
      body.style.setProperty("--color-primary", color)
      body.style.setProperty("--color-ring",    color)
    }

    // Anuncia ao leitor de tela via toast (live region polite).
    const message = isDark ? this.announceDarkValue : this.announceLightValue
    if (message) {
      document.dispatchEvent(new CustomEvent("toast", {
        detail: { message, variant: "default", duration: 2000 }
      }))
    }

    // Persiste no servidor (cookie + user.theme se logado).
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch("/theme", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": token || "",
        "Accept": "application/json"
      },
      body: `theme=${theme}`
    }).catch(() => {
      // Falha de rede: a UI já trocou, será re-sincronizada no próximo request.
    })
  }
}
